import { render, staticRenderFns } from "./TemplateMail.vue?vue&type=template&id=8224aab2&scoped=true&"
import script from "./TemplateMail.vue?vue&type=script&lang=js&"
export * from "./TemplateMail.vue?vue&type=script&lang=js&"
import style0 from "./TemplateMail.vue?vue&type=style&index=0&id=8224aab2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8224aab2",
  null
  
)

export default component.exports